module.exports = __webpack_public_path__ + "static/media/HDJN13.155374b5.jpg";